<ipos-sidebar></ipos-sidebar>
<article>
    <div class="header bg-white pb-6">
        <div class="container-fluid">
            <div class="header-body">
                <div class="row align-items-center py-2 bg-white mb-4">
                    <div class="col-lg-6 col-7">
                        <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
                            <ol class="breadcrumb breadcrumb-links breadcrumb-dark">
                                <li class="breadcrumb-item">
                                    <i class="fas fa-home"></i>
                                </li>
                                <li class="breadcrumb-item">Dashboard</li>
                                <li class="breadcrumb-item active" aria-current="page">
                                    Default
                                </li>
                            </ol>
                        </nav>
                    </div>

                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="card p-4">
                            <div class="bg-transparent">
                                <div class="row align-items-center">
                                    <div class="col">
                                        <h2 class="h1 mb-0"><strong style="font-weight: 600;"> <span class="text-primary">Bhatbhatine Supermarket</span></strong></h2>
                                        <label class="mt-1"><i class="fa fa-map-marker mr-1"></i>Address: New Road, Pokhara-8, Kaski, Nepal</label>
                                        <div class="row">
                                            <div class="col-md-3">
                                                <label class="small"><i class="fa fa-phone mr-1"></i>Phone: 9846517452</label>
                                            </div>
                                            <div class="col-md-3">
                                                <label class="small"><i class="fa fa-user mr-1"></i>Contact person: Manoj Adhikari</label>
                                            </div>
                                            <div class="col-md-3">
                                                <label class="small"><i class="fa fa-align-left mr-1"></i>TID: 654613</label>
                                            </div>
                                            <div class="col-md-3">
                                                <label class="small"><i class="fa fa-align-left mr-1"></i>MID: 6546</label>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-md-3">
                                                <label class="small"><i class="fa fa-align-left mr-1"></i>Serial Number: 6546</label>
                                            </div>
                                            <div class="col-md-3">
                                                <label class="small"><i class="fa fa-map-marker mr-1"></i>Deployed Location: New Road, Pokhara-8, Kaski</label>
                                            </div>
                                            <div class="col-md-3">
                                                <label class="small"><i class="fa fa-align-left mr-1"></i>Date/Time: 2021/6/15</label>
                                            </div>
                                            <div class="col-md-3">
                                                <label class="small"><i class="fa fa-align-left mr-1"></i>Amount: Rs. 6546</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</article>